import ProductEditForm from "./product-edit-form";

export default ProductEditForm;